export default __webpack_public_path__ + "static/media/1470.919cf55f.png";